// Endereço de um anexo de chat.
//
// Os arquivos deixaram de ser servidos estaticamente em /storage, onde
// qualquer um com a URL baixava — sem login, sem sessão, sem empresa. Agora
// passam por `GET /messages/{roomId}/attachment?path=...`, que exige a sala,
// o caminho exato, e uma mensagem daquela sala que realmente o referencie.
//
// A barreira é deliberadamente a MESMA das mensagens: quem conhece a sala já
// lê todo o texto dela pelo mesmo grupo de rotas. Exigir mais para o anexo
// seria incoerente; exigir menos, um buraco.
//
// Num arquivo só porque a montagem estava repetida em cinco telas — e URL de
// recurso protegido duplicada é URL que vai divergir.

const API = String(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

/**
 * @param {string} roomId  identificador da sala (messages.room_id)
 * @param {string} archive caminho relativo guardado na mensagem, ex.: images/x.png
 */
export const chatAttachmentUrl = (roomId, archive) => {
  if (!roomId || !archive) return '';

  // Já é um dado embutido ou um endereço externo: não há o que intermediar.
  if (/^(data:|blob:|https?:)/i.test(archive)) return archive;

  const caminho = String(archive).replace(/^\/+/, '');

  return `${API}/messages/${encodeURIComponent(roomId)}/attachment?path=${encodeURIComponent(caminho)}`;
};

/** Conveniência para quando se tem a mensagem inteira em mãos. */
export const chatAttachmentUrlFromMessage = (message) =>
  chatAttachmentUrl(message?.room_id, message?.archive);
